import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const createPeriodPortal = async (data) => {
  const res = await axiosInstance.post("/timetable-portal/create", data);
  return res.data;
};

export const bulkCreateTimetablePortal = async (data) => {
  const res = await axiosInstance.post("/timetable-portal/bulk-create", data);
  return res.data;
};

export const getTimetableForSectionPortal = async (sectionId) => {
  const res = await axiosInstance.get(`/timetable-portal/section/${sectionId}`);
  return res.data;
};

export const getMyTimetable = async () => {
  const res = await axiosInstance.get("/timetable-portal/my-timetable");
  return res.data;
};

export const getVacantPeriodsPortal = async () => {
  const res = await axiosInstance.get("/timetable-portal/vacant");
  return res.data;
};

export const getOngoingPeriodsPortal = async () => {
  const res = await axiosInstance.get("/timetable-portal/ongoing");
  return res.data;
};

export const updatePeriodPortal = async (id, data) => {
  const res = await axiosInstance.put(`/timetable-portal/update/${id}`, data);
  return res.data;
};

export const deletePeriodPortal = async (id) => {
  const res = await axiosInstance.delete(`/timetable-portal/delete/${id}`);
  return res.data;
};
